import { useEffect, useRef } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { viewport, miniApp } from "@tma.js/sdk";
import { AppInitializer } from "./shared/app-init/AppInitializer";

export default function App() {
  const isInitializedRef = useRef(false);
  const isTelegram = typeof window !== 'undefined' && (window as any).Telegram?.WebApp;

  if (isTelegram && !isInitializedRef.current) {
    try {
      miniApp.ready();
      miniApp.mount();
      miniApp.setHeaderColor('bg_color');
      
      isInitializedRef.current = true;
    } catch (error) {
      console.warn('Early init failed', error);
    }
  }

  useEffect(() => {
    if (!isTelegram) return;

    const setupViewport = async () => {
      try {
        if (!viewport.isMounted()) viewport.mount();
        await viewport.requestFullscreen();
      } catch (e) {
        console.warn('Viewport fullscreen failed', e);
      }
    };

    setupViewport();
  }, [isTelegram]);

  return (
    <AppInitializer>
      <RouterProvider router={router} />
    </AppInitializer>
  );
}